import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setDeleteSupplierId, setUpdateSupplierId} from "../../actions/supplier";
import {Link} from "react-router-dom";
import {useHistory} from 'react-router-dom'
import {Edit, Eye, Trash2} from "react-feather";

const SupplierItem = ({
                          auth,
                          setDeleteSupplierId,
                          setUpdateSupplierId,
                          number,
                          supplier: {
                              id, name, contractor,
                              inn, phone,
                              is_special_client,
                              bank_account, client_id,
                              client,
                              date: created_at
                          },
                          showActions,
                      }) => {

    const {role_name} = auth?.user || {};

    const setDeleteSupplier = (id) => {
        setDeleteSupplierId(id);
    };

    const setUpdateSupplier = (id) => {
        setUpdateSupplierId(id);
    };

    return (
        <Fragment>
            <tr>
                <th scope="row">{number}</th>
                <td>{name}</td>
                <td>{contractor}</td>
                <td>{inn}</td>
                <td>
                    <Link to={`clients/${client_id}`}>{client?.name}</Link>
                </td>
                <td>{phone}</td>
                <td>{bank_account}</td>
                <td>
                    <div className="actions">
                        <Link to={`suppliers/${id}`}>
                            <Eye/>
                        </Link>
                        {
                            role_name == 'director' || role_name == 'superadmin' || role_name == 'manager' ? (
                                <Edit onClick={() => setUpdateSupplier(id)}/>
                            ) : ''
                        }
                        {
                            role_name == 'director' || role_name == 'superadmin' ? (
                                <Trash2 onClick={() => setDeleteSupplier(id)}/>
                            ) : ''
                        }
                    </div>
                </td>
            </tr>
        </Fragment>
    );
};

SupplierItem.defaultProps = {
    showActions: true,
};

SupplierItem.propTypes = {
    supplier: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, {setDeleteSupplierId, setUpdateSupplierId})(
    SupplierItem
);
